{
  "iframe": "Добавить фрейм",
  "image": "Добавить изображение",
  "link": "Добавить ссылку",
  "file": "Добавить файл"
}
